export default __webpack_public_path__ + "static/media/Logo.19583671.jpg";